module.exports = {

  init () {

    if (!document.querySelector('#filter-projects')) return
    
    document
    .querySelector('#filter-projects')
    .addEventListener('change', this.submit)
    
    document
    .querySelector('#project-search')
    .addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        this.submit()
        e.preventDefault()
      }
    })
    
    document
    .querySelector('.project-search .clear')
    .addEventListener('click', () => {
      document.querySelector('#filter-projects').value = ''
      document.querySelector('#project-search').value = ''
      this.submit()
    })

  },
  
  submit() {

    $.ajax({
      url: ajax_object.ajax_url,
      data: {
        'action': 'project_search',
        'project': document.querySelector('#filter-projects').value,
        'search_term': document.querySelector('#project-search').value,
      },
      type: 'POST',
      beforeSend: function() {
        document
        .querySelector('.projects-list')
        .style.opacity = '0.5'
      },
      success: function(res) {
        document
        .querySelector('.projects-list')
        .innerHTML = res

        const url = new URL(window.location)
        url.searchParams.set('search_term', document.querySelector('#project-search').value)
        url.searchParams.set('project', document.querySelector('#filter-projects').value)
        window.history.pushState({}, '', url)

        document
        .querySelector('.projects-list')
        .style.opacity = '1'
      }
    })
  }

}
